import type { MenuItems } from "@/modules/menu";

import {
  useMenuItemLink,
  useMenuItemLogoutAction,
  useMenuSelectedKeys,
  useMenuItemNotificationSettings,
} from "@/modules/menu";

export const useUserDropdownMenu = () => {
  const menuItems: MenuItems = [
    useMenuItemLink("password"),
    useMenuItemNotificationSettings(),
    useMenuItemLink("language"),
    { type: "divider" },
    useMenuItemLogoutAction(),
  ];

  const { selectedKeys } = useMenuSelectedKeys(menuItems);

  return {
    items: menuItems,
    selectedKeys,
  };
};
